module.exports = "/_next/static/images/ai-expreg-demo1-c62e2ea6a46716c9f5f63cf119ea3112.jpg";